import TagManager, { DataLayerArgs, TagManagerArgs } from 'react-gtm-module'

import {
  TagManagerAction,
  TagManagerEventType,
  TagManagerPage,
} from '~/platform/utils/googleTagManager/tagManagerModels'

export const initializeTagManager = () => {
  const tagManagerArgs: TagManagerArgs = {
    gtmId: import.meta.env.VITE_GTM_ID,
  }

  TagManager.initialize(tagManagerArgs)
}

export const triggerTagManagerEvent = (
  event: TagManagerEventType,
  action?: TagManagerAction,
  page?: TagManagerPage,
) => {
  const tagManagerEventArgs: DataLayerArgs = {
    dataLayer: {
      ...(page && { page }),
      event,
      ...(action && { action }),
    },
  }
  TagManager.dataLayer(tagManagerEventArgs)
}
